import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { emitWalletAccountsChangedEvent } from '../../../wallets/emitWalletAccountsChangedEvent';
import { getWalletAccountsFromState } from '../../../wallets/getWalletAccounts/getWalletAccountsFromState';

type CheckAndRaiseWalletAccountsChangedEventParams = {
  previousState: Readonly<DynamicCoreState>;
};

/** @notInstrumented */
export const checkAndRaiseWalletAccountsChangedEvent = (
  { previousState }: CheckAndRaiseWalletAccountsChangedEventParams,
  client: DynamicClient
) => {
  const core = getCore(client);

  const walletAccountsHashBefore = getWalletAccountsHash(previousState, client);

  const walletAccountsHashAfter = getWalletAccountsHash(
    core.state.get(),
    client
  );

  if (walletAccountsHashBefore !== walletAccountsHashAfter) {
    emitWalletAccountsChangedEvent(client);
  }
};

 
 
const getWalletAccountsHash = (
  state: Readonly<DynamicCoreState>,
  client: DynamicClient
) =>
  getWalletAccountsFromState(state, client)
    .map((walletAccount) => JSON.stringify(walletAccount))
    .sort()
    .join('-');
